import type { NextPage } from 'next'
import { useEffect, useRef, useState } from 'react'

interface IProps {
}


const Layout: NextPage<IProps> = ({ children }) => {
  return (
    <div className="h-full">
      {children}
    </div>
  );
};

export default Layout
